import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, Data } from '@angular/router';
import { FleetGrowthFeatureFlagService } from '@services/feature-flags/growth';

@Injectable()
export class MarketplaceExpansiontAccessGuard implements CanActivate {
  constructor(private router: Router, private fgFeatureFlagService: FleetGrowthFeatureFlagService) { }

  public canActivate(route: ActivatedRouteSnapshot): Promise<boolean> | boolean {
    const data: Data = route.data;
    const config: any = data.statsigFeatureGuard;
    const { redirectTo } = config;

    const featureFlagStatus: boolean = this.fgFeatureFlagService.isMarketplaceExpansionEnabled();
    if (!featureFlagStatus) {
      this.router.navigate([redirectTo]);
    }

    return featureFlagStatus;
  }
}